var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',[_c('div',{staticClass:"section bg-gray-200 border-b-4 border-black px-0 lg:px-1"},[_c('div',{staticClass:""},[_c('Navbar',{ref:"navbar"})],1)]),_vm._t("default"),_c('Footer')],2),_c('Web3ConnectModal'),_c('AccountSidenav')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }